import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-narrow",
  "use": "icon-icon-narrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-narrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M949.948 949.645a30 30 0 0 1-42.426 0L725.443 769.363c-157.154 134.875-394.169 127.879-543.036-20.989-156.21-156.21-156.21-409.476 0-565.685s409.475-156.21 565.685 0c149.278 149.278 155.887 387.182 19.856 544.324l182 180.2a30 30 0 0 1 0 42.432zM705.666 225.113c-132.779-132.776-348.055-132.776-480.835 0s-132.778 348.054 0 480.833 348.054 132.778 480.833 0 132.78-348.053 0.002-480.833z m-520.635 240.2a30 30 0 0 1 30-30h500a30 30 0 0 1 0 60h-500a30 30 0 0 1-30-30z\" p-id=\"1249\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-narrow.svg
// module id = 4sbN
// module chunks = 1